import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from "@angular/core";
import { CmsManagementService } from "../../modules/cms-management/services/cms-management.service";
import { PopupService } from "../popup/popup.service";
import { TranslateConfigService } from "src/app/core/services/translate-config.service";
import { ModelService } from "../components/model/model.service";
import { ConfirmModalService } from "../confirm-modal/confirm-modal.service";

@Directive({
  selector: "[translatable]",
})
export class Translatable {
  cmsMode = this.cmsManagementService.getCMSMode();

  @Input() translatable: any;

  constructor(
    private cmsManagementService: CmsManagementService,
    private el: ElementRef,
    private renderer: Renderer2,
    private popupSer: PopupService,
    private confirmationPopupService: ConfirmModalService,
    private modelService: ModelService,
    private translateConfigService: TranslateConfigService
  ) {}

  ngOnInit() {
    this.cmsManagementService.cmsModeChanged.subscribe(cmsMode => {
      this.cmsMode = cmsMode;
      if (cmsMode && this.translatable.transKey) {
        this.insertBtnToView();
      }
      if (!cmsMode) {
        this.removeBtnFromView();
      }
    });
  }

  ngAfterContentInit() {
    if (this.cmsMode && this.translatable.transKey) {
      this.insertBtnToView();
    }
  }

  // This function customizing the element that used by this directive to add buttonIcon that able to open modal form.
  insertBtnToView() {
    // Create a buttonIcon element
    const buttonIcon = this.renderer.createElement("i");
    buttonIcon.className = "isax isax-card-edit translatable-edit-icon";

    // Add custom styles to wrapper and buttonIcon
    buttonIcon.style.cssText =
      "cursor: pointer;margin: 0 0.5rem; color:#e56e83; z-index: 111;";
    this.el.nativeElement.style.cssText += "display: flex;align-items: center;";

    // Append the buttonIcon to the host element
    this.renderer.appendChild(this.el.nativeElement, buttonIcon);

    // Add a click event listener to the buttonIcon
    this.renderer.listen(buttonIcon, "click", event => {
      event.stopPropagation();
      console.log(event);
      
      // Handle buttonIcon click logic here
      const selectedValue = this.translateConfigService.getLangText(
        this.translatable?.transKey
      );

      this.openModal(event, {
        translationKey: this.translatable?.transKey,
        translationModuleEnum: this.translatable?.modEnum,
        selectedValueForTranslation: selectedValue,
      });
    });
  }

  // This function removing the translatable directive btn from the view.
  removeBtnFromView(){
    document.querySelectorAll('.translatable-edit-icon').forEach(el => el.remove());
    this.el.nativeElement.style.cssText = "";
    // console.log(this.renderer);
    // console.log(this.el);
    
  }

  openModal(event, selectedTranslationObj) {
    this.cmsManagementService.selectedTranslationObj.next(
      selectedTranslationObj
    );
    this.modelService.close();
    this.popupSer.close();
    this.confirmationPopupService.close();
    this.popupSer.open("cms-mode-modal");
  }
}
